var THREE = require("three");

// IMPORTS:
const config = require(/*! ../config.js */"../config.js");
const UTILS = require(/*! ./utils.js */"./utils.js");

// COLORS:
var colors = {};
module.exports.getColor = function (color, mlt) {
  var tmpIndx = color + "-" + (mlt || "");
  var tmpCol = colors[tmpIndx];
  if (!tmpCol) {
    tmpCol = new THREE.Color(color);
    if (mlt) {
      tmpCol.multiplyScalar(mlt);
    }
    colors[tmpIndx] = tmpCol;
  }
  return tmpCol;
};

// COLORIZE:
module.exports.colorize = function (geo, color, colorO) {
  color = colorO || module.exports.getColor(color);
  for (var i = 0; i < geo.faces.length; ++i) {
    geo.faces[i].vertexColors[0] = color;
    geo.faces[i].vertexColors[1] = color;
    geo.faces[i].vertexColors[2] = color;
  }
};

// UVS:
var tmpGeo;
function scaleUV(geo, x, y, s) {
  var scaleVector = new THREE.Vector2(x, y).multiplyScalar(s || 1);
  for (var i = 0; i < geo.faceVertexUvs.length; i++) {
    var uv = geo.faceVertexUvs[i];
    for (var j = 0; j < uv.length; j++) {
      for (var k = 0; k < 3; k++) {
        var v = uv[j][k].multiply(scaleVector);
        v.x = 0.5 + v.x - scaleVector.x / 2;
      }
    }
  }
} // POINT IN RECT:
function pointInRect(x, y, x2, y2, w, l) {
  return x >= x2 - w && x <= x2 + w && y >= y2 - l && y <= y2 + l;
} // PLANE GENERATOR:
var cachedPlanes = [];
var faceIndices = ['a', 'b', 'c', 'd'];
module.exports.generatePlane = function (w, l, data, xP, yP, zP) {
  w *= data.ratio || 1;
  var tmpIndx = (data.scale ? w + "_" + l + "_" : "") + (data.scale || "") + (data.tilesX || "") + (data.tilesZ || "") + (data.noise ? xP + "_" + yP + "_" + zP : "") + (data.colr != undefined ? data.colr : "") + (data.dark || "");
  tmpGeo = cachedPlanes[tmpIndx];
  if (!tmpGeo) {
    tmpGeo = new THREE.PlaneGeometry(1, 1, data.tilesX || 1, data.tilesZ || 1);
    if (data.noise) {
      var tmpColors = {};
      var tmpM = data.margin || 0;
      for (var i = 0; i < tmpGeo.vertices.length; ++i) {
        var tX = tmpGeo.vertices[i].x;
        var tY = tmpGeo.vertices[i].y;
        if (!data.pinEdges || tX != -0.5 && tX != 0.5 && tY != -0.5 && tY != 0.5) {
          if (data.objects) {
            for (var x = 0; x < data.objects.length; ++x) {
              if (data.objects[x].y - data.objects[x].height <= yP + 0.1 && data.objects[x].y + data.objects[x].height > yP + data.noise && pointInRect(zP + -tY * w * 2, xP + tX * l * 2, data.objects[x].z, data.objects[x].x, data.objects[x].length + tmpM, data.objects[x].width + tmpM)) {
                tmpGeo.vertices[i].z = Math.random() * data.noise + 1;
                tmpColors[i] = module.exports.getColor(data.colr, 0.6);
                break;
              }
            }
          } else {
            tmpGeo.vertices[i].z = Math.random() * data.noise;
          }
        }
        if (!tmpColors[i]) {
          tmpColors[i] = module.exports.getColor(data.colr);
        }
      }

      // APPLY COLORS AND CLEAN GEO:
      for (var i = 0; i < tmpGeo.faces.length; i++) {
        var tmpFace = tmpGeo.faces[i];
        var removeC = 0;
        for (var j = 0; j < 3; j++) {
          tmpFace.vertexColors[j] = tmpColors[tmpFace[faceIndices[j]]];
          if (tmpGeo.vertices[tmpFace[faceIndices[j]]].z <= 0) {
            removeC++;
          }
        }
        if (removeC >= 3) {
          delete tmpGeo.faces[i];
        }
      }
      tmpGeo.faces = tmpGeo.faces.filter(function (v) {
        return v;
      });
      tmpGeo.elementsNeedUpdate = true;
    } else {
      module.exports.colorize(tmpGeo, null, module.exports.getColor(data.colr || 0xffffff, data.dark || 1));
    }
    if (data.scale) {
      scaleUV(tmpGeo, l / config.worldUV, w / config.worldUV, data.scale);
    }
    tmpGeo.computeVertexNormals();
    cachedPlanes[tmpIndx] = tmpGeo;
  }
  return tmpGeo;
};

// CUBE GENERATOR:
var cachedCubes = [];
module.exports.generateCube = function (sides, w, h, l, data) {
  sides = sides || [1, 1, 1, 1, 1, 1];
  data.flipp = (w > h || l > h) && data.src == "floor_0";
  data.flippW = w > l && data.src == "floor_0";
  var tmpIndx = (data.scale ? w + "_" + h + "_" + l + "_" : "") + (data.colr != undefined ? data.colr : "") + (data.scale || "") + (data.flippW ? "flw" : "fnw") + (data.flipp ? "fl" : "fn") + (data.amb || "") + (data.fAmb || "") + (data.useScale || "");
  for (var i = 0; i < sides.length; ++i) {
    tmpIndx += "_" + sides[i];
  }
  tmpGeo = cachedCubes[tmpIndx];
  if (!tmpGeo) {
    // COLORS:
    data.colr = data.colr != undefined ? data.colr : 0xffffff;
    var light = module.exports.getColor(data.colr);
    var shadow = data.amb ? module.exports.getColor(data.colr, data.amb) : light;
    if (data.fAmb) {
      var tmpLi = light;
      light = shadow;
      shadow = tmpLi;
    }

    // CREATE OBJECTS:
    tmpGeo = new THREE.Geometry();
    var geos = [];
    var tmpPlane;
    if (sides[0]) {
      // Right
      tmpPlane = new THREE.PlaneGeometry(1, 1);
      tmpPlane.rotateY(Math.PI / 2);
      if (data.flipp) {
        tmpPlane.rotateX(Math.PI / 2);
      }
      tmpPlane.translate(.5, .5, 0);
      tmpPlane.faces[0].vertexColors = [light, shadow, light];
      tmpPlane.faces[1].vertexColors = [shadow, shadow, light];
      if (data.scale) {
        scaleUV(tmpPlane, (data.flipp ? h : l) / config.worldUV, (data.flipp ? l : h) / config.worldUV, data.scale);
      }
      geos.push(tmpPlane);
    }
    if (sides[1]) {
      // Left
      tmpPlane = new THREE.PlaneGeometry(1, 1);
      tmpPlane.rotateY(-Math.PI / 2);
      if (data.flipp) {
        tmpPlane.rotateX(Math.PI / 2);
      }
      tmpPlane.translate(-.5, .5, 0);
      tmpPlane.faces[0].vertexColors = [light, shadow, light];
      tmpPlane.faces[1].vertexColors = [shadow, shadow, light];
      if (data.scale) {
        scaleUV(tmpPlane, (data.flipp ? h : l) / config.worldUV, (data.flipp ? l : h) / config.worldUV, data.scale);
      }
      geos.push(tmpPlane);
    }
    if (sides[2]) {
      // Top
      tmpPlane = new THREE.PlaneGeometry(1, 1);
      tmpPlane.rotateX(-Math.PI / 2);
      if (data.flippW) {
        tmpPlane.rotateY(Math.PI / 2);
      }
      tmpPlane.translate(0, 1, 0);
      tmpPlane.faces[0].vertexColors = [light, light, light];
      tmpPlane.faces[1].vertexColors = [light, light, light];
      if (data.scale) {
        scaleUV(tmpPlane, (data.flippW ? l : w) / config.worldUV, (data.flippW ? w : l) / config.worldUV, data.scale);
      }
      geos.push(tmpPlane);
    }
    if (sides[3]) {
      // Bottom
      tmpPlane = new THREE.PlaneGeometry(1, 1);
      tmpPlane.rotateX(Math.PI / 2);
      if (data.flippW) {
        tmpPlane.rotateY(Math.PI / 2);
      }
      tmpPlane.translate(0, 0, 0);
      tmpPlane.faces[0].vertexColors = [shadow, shadow, shadow];
      tmpPlane.faces[1].vertexColors = [shadow, shadow, shadow];
      if (data.scale) {
        scaleUV(tmpPlane, (data.flippW ? l : w) / config.worldUV, (data.flippW ? w : l) / config.worldUV, data.scale);
      }
      geos.push(tmpPlane);
    }
    if (sides[4]) {
      // Back
      tmpPlane = new THREE.PlaneGeometry(1, 1);
      if (data.flipp) {
        tmpPlane.rotateZ(Math.PI / 2);
      }
      tmpPlane.translate(0, .5, .5);
      tmpPlane.faces[0].vertexColors = [light, shadow, light];
      tmpPlane.faces[1].vertexColors = [shadow, shadow, light];
      if (data.scale) {
        scaleUV(tmpPlane, (data.flipp ? h : w) / config.worldUV, (data.flipp ? w : h) / config.worldUV, data.scale);
      }
      geos.push(tmpPlane);
    }
    if (sides[5]) {
      // Front
      tmpPlane = new THREE.PlaneGeometry(1, 1);
      tmpPlane.rotateY(Math.PI);
      if (data.flipp) {
        tmpPlane.rotateZ(Math.PI / 2);
      }
      tmpPlane.translate(0, .5, -.5);
      tmpPlane.faces[0].vertexColors = [light, shadow, light];
      tmpPlane.faces[1].vertexColors = [shadow, shadow, light];
      if (data.scale) {
        scaleUV(tmpPlane, (data.flipp ? h : w) / config.worldUV, (data.flipp ? w : h) / config.worldUV, data.scale);
      }
      geos.push(tmpPlane);
    }
    for (var i = 0; i < geos.length; i++) {
      tmpGeo.merge(geos[i], new THREE.Matrix4());
    }
    if (data && data.useScale) {
      tmpGeo.scale(w, h, l);
      tmpGeo.translate(0, -h / 2, 0);
    }
    cachedCubes[tmpIndx] = tmpGeo;
  }
  return tmpGeo;
};